import { User } from "@/interfaces/user";
import { api } from "@/services/api";
import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query";

export interface ICreateTicket {
  id: number;
  event: string;
  team1: string;
  team2: string;
  betType: string;
  betValue: string | number;
  betName: string;
  linkUrl: string;
  odd: string | number;
  matchDate: Date | string;
  updated_at?: string;
  created_at?: string;
  deleted_at?: string;
}

export interface IGetUsers {
  allUsersCount: number;
  data: (User & { balance: number; pending_balance: number })[];
}

export const mutateCreateTicket = (
  options?: UseMutationOptions<ICreateTicket, Error, ICreateTicket>
) => {
  const response = useMutation({
    mutationFn: async (data: ICreateTicket) => {
      const res = await api.post("admin/ticket", data);
      return res.data.data;
    },

    ...options,
  });

  return response;
};

export const mutateEditTicket = (
  options?: UseMutationOptions<number, Error, ICreateTicket>
) => {
  const response = useMutation({
    mutationFn: async ({ id, ...data }) => {
      const res = await api.put(`/admin/ticket/${id}`, data);
      return res.data.data;
    },

    ...options,
  });

  return response;
};

export const mutateDeleteTicket = (
  options?: UseMutationOptions<string, Error, string>
) => {
  const response = useMutation({
    mutationFn: async (betName) => {
      const res = await api.delete(`/admin/deleteTicket/${betName}`);
      return res.data.data;
    },

    ...options,
  });

  return response;
};

export const mutateDeleteBet = (
  options?: UseMutationOptions<number, Error, number>
) => {
  const response = useMutation({
    mutationFn: async (id) => {
      const res = await api.delete(`/admin/deleteBet/${id}`);
      return res.data.data;
    },

    ...options,
  });

  return response;
};

export const fetchGetAllUsers = (
  page: number,
  pageSize: number,
  search: string,
  options?: Partial<UseQueryOptions<IGetUsers>>
) => {
  const response = useQuery({
    queryKey: ["admin/getUsers", page, pageSize, search],
    queryFn: async () => {
      const res = await api.get("admin/getUsers", {
        params: { page, pageSize, search },
      });
      return res.data.data;
    },
    ...options,
  });

  return response;
};

export const fetchGetTickets = (
  options?: Partial<UseQueryOptions<ICreateTicket[]>>
) => {
  const response = useQuery({
    queryKey: ["admin/tickets"],
    queryFn: async () => {
      const res = await api.get("admin/tickets");
      return res.data.data;
    },
    ...options,
  });

  return response;
};
